export const Divider = () => {
  return <div className="h-full w-[1px] bg-gray-200"></div>;
};
